import { render, staticRenderFns } from "./StackSummary.vue?vue&type=template&id=177c31f4&scoped=true&"
import script from "./StackSummary.vue?vue&type=script&lang=js&"
export * from "./StackSummary.vue?vue&type=script&lang=js&"
import style0 from "./StackSummary.vue?vue&type=style&index=0&id=177c31f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177c31f4",
  null
  
)

export default component.exports